import { SPACING } from 'd2/constants'
import { px } from 'd2/utils/style'
import makeStyles from 'd2/hooks/tss/makeStyles'

export const NAV_HEIGHT = 86
export const NAV_PLUS_HEADER_HEIGHT = 142

const styles = () => ({
  headerSpacing: {
    maxHeight: `calc(100vh - ${px(NAV_PLUS_HEADER_HEIGHT)})`,
    top: px(NAV_PLUS_HEADER_HEIGHT),
  },
  navSpacing: {
    maxHeight: `calc(100vh - ${px(NAV_HEIGHT)})`,
    top: px(NAV_HEIGHT),
  },
  navWithPadding: {
    maxHeight: `calc(100vh - ${px(NAV_HEIGHT + SPACING)})`,
    top: px(NAV_HEIGHT + SPACING),
  },
  noneSpacing: {
    maxHeight: '100vh',
    top: 0,
  },
  sticky: {
    alignSelf: 'flex-start',
    position: 'sticky',
  },
} as const)

export default makeStyles({
  name: 'Sticky',
})(styles)
